<template>
    <a-drawer title="字典项管理" :visible="visible" :wrap-class-name="drawerWrapClassName" destroy-on-close
              :mask-closable="false" @close="onClose" :width="1200">
        <div class="ant-drawer-main">
            <a-form class="table-search" ref="searchForm" layout="inline" :model="searchForm">
                <a-form-item label="字典项名称" name="dictTitle">
                    <a-input v-model:value="searchForm.dictTitle" placeholder="请输入字典项名称"/>
                </a-form-item>
                <a-form-item label="字典项值" name="dictValue">
                    <a-input v-model:value="searchForm.dictValue" placeholder="请输入字典项值"/>
                </a-form-item>
                <a-form-item>
                    <a-button type="primary" @click="onSearch">查询</a-button>
                    <a-button @click="onReset">重置</a-button>
                </a-form-item>
            </a-form>
            <div class="table-toolbar">
                <a-button type="primary" @click="onAdd">
                    <template #icon>
                        <plus-outlined/>
                    </template>
                    新增
                </a-button>
            </div>
            <a-alert type="info" showIcon class="table-alert" v-if="selectedRowKeys.length">
                <template #message>
                    已选择 {{ selectedRowKeys.length }} 项
                    <a @click="onClearSelected" class="ml-20 float-right">清空</a>
                </template>
            </a-alert>
            <a-table
                :columns="columns"
                :pagination="pagination"
                :data-source="dataSource"
                :loading="loading"
                @change="onTableChange">
                <!-- <template #index="{index}">{{ index + 1 }}</template> -->
                <template #enabled="{record}">
                    <switch-btn
                        :value="record.enabled"
                        key-field="enabled"
                        :switch-url="switchUrl"
                        :params="{id:record.id}"
                        @ok="loadData"/>
                </template>
                <template #action="{record}">
                    <div class="table-row-operations">
                        <a @click="onEdit(record.id)">编辑</a>
                        <a-popconfirm title="确认要删除吗?" @confirm="onDelete(record.id)">
                            <a class="delete">删除</a>
                        </a-popconfirm>
                    </div>
                </template>
            </a-table>
        </div>
    </a-drawer>
    <AddOrEditModal ref="modal" :form-primary-key-field="listKeyField" @finish="onFormEdited"/>
</template>
<script>
import {tableListMixin, popupMixin} from "@/mixins";
import AddOrEditModal from "./AddOrEditDictItem";
import {sys_dict_controller} from "@/api/adminService";

const columns = [
    // {title: "#", dataIndex: "index", key: "index", slots: {customRender: "index"}},
    {title: "字典项名称", dataIndex: "dictTitle", key: "dictTitle"},
    {title: "字典项值", dataIndex: "dictValue", key: "dictValue"},
    {title: "排序", dataIndex: "sort", key: "sort"},
    {title: "是否启用", dataIndex: "enabled", key: "enabled", slots: {customRender: "enabled"}},
    {title: "操作", dataIndex: "action", key: "action", slots: {customRender: "action"}},
];
export default {
    name: "DictItemList",
    mixins: [tableListMixin, popupMixin],
    components: {
        AddOrEditModal,
    },
    data() {
        return {
            columns,
            queryParam: {},
            queryParamFixed: {
                groupNumber: '',
            },
            listUrl: sys_dict_controller.getPageListData,
            listKeyField: "dictId",
            deleteUrl: sys_dict_controller.remove,
            switchUrl: sys_dict_controller.saveOrUpdate,

            immediateLoadData: false,
        }
    },
    methods: {
        onAdd() {
            this.onShowModal("modal", {
                groupNumber: this.queryParamFixed.groupNumber
            });
        },
        onEdit(id) {
            this.getAction({
                url: sys_dict_controller.getDetail,
                params: {id: id},
                returnMsg: true
            }).then(res => {
                this.onShowModal("modal", res.data || {});
            })
        }
    }
}
</script>
<style scoped lang="less">
</style>
